import './route-fallback.css'

// What fills the page while a route's JavaScript is still on the wire.
//
// Page-shaped, not a spinner, for the same reason <SkeletonRows> is: the screen
// must not reflow between "chunk arriving", "data arriving" and "loaded". A
// centred spinner would jump the whole layout twice on the 4G connection this
// split exists for, and a cashier reads that as the app having crashed and
// come back.
//
// It borrows .ui-skel from the component inventory rather than growing a second
// shimmer, which also means one prefers-reduced-motion rule for the system
// instead of one per fallback.

/**
 * @param {{ variant?: 'page' | 'card', rows?: number }} props
 *   `page` fills <main> inside the shell; `card` stands in for the signed-out
 *   screens, which are a centred card on the auth ground and would otherwise
 *   flash a full-width block before the real card lands.
 */
export default function RouteFallback({ variant = 'page', rows = 6 }) {
  // aria-busy on the region, and one live announcement — not one per bar. The
  // bars are decoration; a screen reader that read all eight would say
  // "loading" eight times and still not say what is loading.
  return (
    <div
      className={variant === 'card' ? 'route-fallback route-fallback-auth' : 'route-fallback'}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="visually-hidden">Loading</span>
      <div className="route-fallback-inner" aria-hidden="true">
        <span className="ui-skel route-fallback-eyebrow" />
        <span className="ui-skel route-fallback-title" />
        <div className="route-fallback-panel">
          {Array.from({ length: rows }, (_, r) => (
            <span key={r} className="ui-skel route-fallback-row" />
          ))}
        </div>
      </div>
    </div>
  )
}
